<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Apprenticeship Levy</h1>
    <p>The Apprenticeship Levy is a tax on employers which is used to fund apprenticeship training.</p>
    <p>To assess whether your company is required to pay the Apprenticeship Levy view <a href="https://www.gov.uk/guidance/pay-apprenticeship-levy#who-needs-to-pay-apprenticeship-levy" target="_blank">gov.uk</a></p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="custom-check">
             <input type="checkbox" v-model="formData.hasApprenticeshipLevy">My company is required to pay the Apprenticeship Levy
            <span class="checkmark"></span>
        </label>
              <div v-if="formData.hasApprenticeshipLevy && formData.payrollType === 'existingscheme'">
                <br/>
              <label>Apprenticeship Levy paid during this tax year</label>
                <div class="grid-x grid-margin-x">
                <div class="cell small-3">
                      <input 
                      type="text" 
                      id="apprenticeshipLevyAlreadyPaid" 
                      name="apprenticeshipLevyAlreadyPaid" 
                      placeholder="0.00" 
                      v-model="formData.apprenticeshipLevyAlreadyPaid" 
                      required 
                      inputmode="numeric"
                    >
                </div>
                </div>
            </div>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router';

const error = ref(null)
const route = useRoute();
const taskId = route.params.taskId;

const props = defineProps({
  formData: Object
})


const validateStep = () => {


  return true;
}


import { putDataCollectionTask } from '@/services/implementationmanagement.api';
const executeStep = async () => {

  var payload = {
    version: 1,
    dataJson: JSON.stringify(props.formData),
    schemaName: "Company",
    taskId: taskId,
    taskStatus: "SuccessfullyCompleted"
  }

  var response = await putDataCollectionTask(taskId, payload);

  if (response.status !== 200) {
    error.value = 'Error saving data. Please contact your Qtac account manager.';
    return false;
  }



  return true;
}



onMounted(() => {
});

defineExpose({ validateStep, executeStep });

</script>